// Page fine qui rend simplement votre map + panneau de filtres.
// Aucun overlay, aucun Drawer externe : c’est exactement votre LocalSearchOpen.
import LocalSearchOpen from '../components/Maps/LocalSearchOpen';

export default function CreatePlaylistPage() {
  return <LocalSearchOpen />;
}
